// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"schedule-buttons_wrapper__cFNWz","item":"schedule-buttons_item__S5Ncs","description":"schedule-buttons_description__OkMDF","heading":"schedule-buttons_heading__AnR_2"};